import { createSelector } from 'reselect';
import { createClassicRewardsAvailabilityMessage } from 'lib/search/createClassicRewardsAvailabilityMessage';
import { getQueryDepositPay } from './querySelectors';
import { getIsLoading } from './searchSelectors';

export const getClassicRewardAvailabilityMessage = createSelector(
  getIsLoading,
  getQueryDepositPay,
  createClassicRewardsAvailabilityMessage,
);
